module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.d10ac4ee.ttf";